<div class="fundraising-container">

  <ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>
  
    <div class="search-row align-center">
      <button style="box-shadow: 0 3px 15px 6px rgba(120, 99, 225, 0.22);" class="btn dark-btn" (click)="create()">
        New Fundraiser
      </button>
     <div class="input-with-icon align-row">
        <div class="input-icon align-center"><i class="flaticon-search"></i></div>
        <input
          type="text"
          placeholder="Search"
          (keyup)="search()"
          [(ngModel)]="searchText"
          class="searchtext"
      />
      </div>
    </div>
    <div *ngIf="cue5050s" class="fundraising-table">
      <div class="data-row" *ngFor="let w of displayItems">
        <div class="data-row-content" >
          <div class="content-cell">
            <div style="justify-content: space-between;" class="cell-row">
              <h3 class="fundraiser-title">{{w.event.name}}</h3>
              <div class="dropdown"> 
                <div class="dots">
                  <img/>
                </div>
                <div class="dropdown-content">
                  <a (click)="startEvent(w.eventId)" class="start-tab" *ngIf="w.event.status === 1" href="#">Start Event!</a>
                  <a (click)="cancelEvent(w.eventId)" class="delete-tab" *ngIf="w.event.status === 1" href="#">Cancel Event</a>
                  <a (click)="completeEvent(w.eventId)" class="start-tab" *ngIf="w.event.status === 2" href="#">Complete Event</a>

                  <a *ngIf="w.event.status === 3 && !w.winningTicket && w.event.vendor.enableBarrelPrinting" (click)="openChooseWinnerModal(w.eventId)" class="start-tab" href="#">Submit Winning Ticket Number</a>
                  <a *ngIf="w.event.status === 3 && !w.winningTicket && !w.event.vendor.enableBarrelPrinting" (click)="drawWinner(w.eventId)" class="start-tab" href="#">Draw Winner</a>
                  <a *ngIf="w.event.status === 3 && w.winningTicket && !w.winnerVerified" (click)="setVerification(w.cue5050Id)" class="start-tab" href="#">Verify Winner</a>

                  <a (click)="clone(w.eventId)" href="#">Clone</a>
                  <a *ngIf="w.event.status === 1" (click)="edit(w.eventId)" href="#">Edit</a>
                  <a *ngIf="w.event.status > 1" (click)="edit(w.eventId)" href="#">View</a>
                  <a (click)="openDetailsModal(w.cue5050Id)" href="#">Details</a>
                </div>
              </div>
            </div>
            <div class="cell-row">       
              <div class="block-icon blk"><i class="flaticon-share"></i><span>{{w.event.eventType.formattedName}}</span></div>
              <div *ngIf="w.event.status === 1" class="block-icon status blu"><i class="flaticon-calendar"></i><span>SCHEDULED</span></div>
              <div *ngIf="w.event.status === 4"  class="block-icon status red"><i class="flaticon-cancel"></i><span>CANCELED</span></div>
              <div *ngIf="w.event.status === 2"  class="block-icon status blu-grn"><i class="flaticon-exclamation-2"></i><span>IN PROGRESS</span></div>
              <div *ngIf="w.event.status === 3"  class="block-icon status grn"><i class="flaticon-calendar-1"></i><span>COMPLETED</span></div>

              <div style="cursor: help; padding-top: 8px;" container="body" tooltip="The funds from this event have been deposited in your bank account" *ngIf="w.event.status === 3 && w.event.payoutStatus === 'complete'" class="block-icon status grn"><span>PAYOUT COMPLETE</span></div>
              <div style="cursor: help; padding-top: 8px;" container="body" tooltip="The funds from this event have yet to be settled" *ngIf="w.event.status === 3 && w.event.payoutStatus === 'pending'" class="block-icon status org"><span>PAYOUT PENDING</span></div>
              <div style="cursor: help; padding-top: 8px;" container="body" tooltip="The funds from this event are scheduled to be deposited" *ngIf="w.event.status === 3 && w.event.payoutStatus === 'scheduled'" class="block-icon status blu"><span>PAYOUT SCHEDULED</span></div>
              <div style="cursor: help;" container="body" tooltip="The winning ticket has not been selected" *ngIf="w.event.status === 3 && !w.winningTicket" class="block-icon status org"><i class="flaticon-warning-2"></i><span>REQUIRES ACTION</span></div>
              <div style="cursor: help;" container="body" tooltip="The winning ticket has not been verified" *ngIf="w.event.status === 3 && !w.winnerVerified && w.winningTicket" class="block-icon status org"><i class="flaticon-warning-2"></i><span>REQUIRES VERIFICATION</span></div> 
              <div style="cursor: help;" container="body" tooltip="The winning ticket has been selected and verfied" *ngIf="w.event.status === 3 && w.winnerVerified && w.winningTicket" class="block-icon status blu"><i class="flaticon-confetti"></i><span>WINNER VERIFIED!</span></div> 
            </div>
            <div class="cell-row">
              <div>       
                <div class="info-container">
                  <span class="info-content">{{w.event.merchant.name}}</span> 
                  <span class="info-title">Charity</span>
                </div>
                <div class="info-container">
                  <span class="info-content">{{w.event.vendor.name}}</span> 
                  <span class="info-title">Vendor</span>
                </div>
                <div class="info-container">
                  <span class="info-content">{{w.event.location.name}}</span> 
                  <span class="info-title">Venue</span>
                </div>
              </div>
              <div>
                <div *ngIf="!w.winningTicket" style="cursor:help" class="info-container" tooltip="Winner Select Time: {{formatTime(w.winnerSelectTime) | date: 'h:mm a'}}">
                  <span class="info-content">{{w.event.realStartDateTime | date:'MM/d'}} - {{w.event.realEndDateTime | date:'MM/d'}}</span> 
                  <span class="info-title">Duration</span>
                </div>
                <div *ngIf="w.winningTicket" class="info-container">
                  <span class="info-content">{{w.winningTicket.ticketNumber}}</span> 
                  <span class="info-title">Winning Ticket</span>
                </div>
                <div class="info-container">
                  <span *ngIf="w.event.status === 1 || w.event.status === 4" class="info-content">- -</span> 
                  <span *ngIf="w.event.status === 2 || w.event.status === 3" class="info-content">{{w.currentPot / 100 | currency }}</span>
                  <span class="info-title">Current Pot</span>
                </div>
                <div class="info-container">
                  <span *ngIf="w.event.status === 1 || w.event.status === 4" class="info-content">- -</span> 
                  <span *ngIf="w.event.status === 2 || w.event.status === 3" class="info-content">{{w.ticketsSold}}</span> 
                  <span class="info-title">Tickets Sold</span>
                </div>  
              </div>   
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!(cue5050s && cue5050s.length !== 0)"> No Fundraising Campaigns to show, click 'New Fundraising Campaign' to begin</div>
    </div>
  </div>
  